import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { Results } from '@local/client-contracts';
import { STYLE_SERVICE } from '@local/ui-infra';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { HighlightStyle } from '@shared/pipes';
import { StyleService } from '@shared/services/style.service';
import { Command } from '@unleash-tech/apps-client-sdk';
import { HubService } from 'src/app/bar/services/hub.service';

@UntilDestroy()
@Component({
  selector: 'result-rich-text-link',
  templateUrl: './result-rich-text-link.component.html',
  styleUrls: ['./result-rich-text-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultRichTextLinkComponent implements OnInit {
  highlightStyle: HighlightStyle = 'default';
  theme: string;

  @Input() model: Results.RichTextLink;
  @Input() highlights: Array<string>;

  @Output() invoke = new EventEmitter<Command.Command>();

  constructor(private hubService: HubService, @Inject(STYLE_SERVICE) private styleService: StyleService, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.theme = 'light';
    this.cdr.markForCheck();
    this.styleService.theme$.pipe(untilDestroyed(this)).subscribe((theme: any) => {
      this.theme = theme;
      this.cdr.markForCheck();
    });
  }


  openUrl() {
    if (!this.model.onClick) return;
    this.invoke.emit(this.model.onClick);
  }
}
